import Editor from "./Editor.js";
export default Editor;
